import React, { useState, useEffect } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import FormFilters from "./FormFilters";
import QuestsListElement from "../../assets/components/questListElement";
import { useNavigate } from "react-router";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import Loading from "../../assets/containers/loadingDialog";
import StartExamAlert from "./StartExamDialog";

const FormsList = () => {
  const [filter, setFilter] = useState("Active");
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);
  const [openExamProceedDialog, setOpenExamProceedDialog] = useState(false);
  const [examId, setExamId] = useState(null);
  const [createExamLoading, setCreateExamLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getAllForms(filter);
  }, [filter]);

  const getAllForms = async (type) => {
    setLoading(true);
    try {
      await appApi
        .get(`/form/getuser?page=1&limit=999&searchString=${type}`)
        .then(({ data }) => {
          setForms(data.docs);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const createExam = async (id) => {
    setCreateExamLoading(true);
    try {
      // The form endpoint requires an existing exam ticket before it can load.
      const { data } = await appApi.post("/formticket/create", { form: id });
      navigate(`/form/${data.form}`);
    } catch (error) {
      errorHandler(error);
    } finally {
      setCreateExamLoading(false);
      setOpenExamProceedDialog(false);
    }
  };

  const handleCheckAndAct = async (id) => {
    setLoading(true);
    try {
      await appApi.get(`/form/prefillcheck/${id}`).then(({ data }) => {
        setLoading(false);
        if (data.type === "Exam") {
          setOpenExamProceedDialog(true);
          setExamId(id);
          return;
        } else {
          navigate(`/form/${id}`);
          setExamId(null);
        }
      });
    } catch (error) {
      if (error.response.data.filledForm) {
        navigate(`/formQR/${error.response.data.filledForm._id}`, {
          state: {
            showMessage: error.response.data.form.confirmation === "Message",
          },
        });
      } else {
        errorHandler(error);
      }
      setLoading(false);
    }
  };

  return (
    <>
      <AnimatedPageContainer>
        <div className="customContainer mt-4">
          <FormFilters
            selected={filter}
            handleClick={(type) => setFilter(type)}
          />
          {loading ? (
            <div className="w-100 d-flex justify-content-center py-5 my-5">
              <Loading size={30} />
            </div>
          ) : forms.length !== 0 ? (
            forms.map((item, index) => {
              return (
                <QuestsListElement
                  key={index}
                  isEvent={true}
                  title={item.title}
                  subTitle={item.subtitle}
                  handleClick={() => handleCheckAndAct(item._id)}
                />
              );
            })
          ) : (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          )}
        </div>
      </AnimatedPageContainer>
      <StartExamAlert
        show={openExamProceedDialog}
        form={forms.find((form) => form._id === examId)}
        startExam={() => {
          createExam(examId);
        }}
        loading={createExamLoading}
        handleClose={() => setOpenExamProceedDialog(false)}
      />
    </>
  );
};

export default FormsList;
